import WorldSystem from '../WorldSystem';
import { IPlayerStateTaskData } from '../../../State/Player/IPlayerState';
import CreateShortcutTask from './CreateShortcutTask';
import UnlockBackCardTask from './UnlockBackCardTask';
import LevelNodeCompleteTask from './LevelNodeCompleteTask';
import AnimationTask from '../../../Utility/Task/AnimationTask';

export default class RewardAnimationHelper {
    public static earnCoins(
        system: WorldSystem,
        taskData: IPlayerStateTaskData
    ): void {
        system.taskQueue.queue(
            new AnimationTask('RewardCoins', system.animator, {
                scene: system.scene,
                type: taskData.type,
                coins: taskData.coins,
                previousCoins: taskData.previousCoins,
            })
        );
    }

    public static spendCoins(
        system: WorldSystem,
        taskData: IPlayerStateTaskData
    ): void {
        system.taskQueue.queue(
            new AnimationTask(
                'SpendCoins',
                system.animator,
                {
                    scene: system.scene,
                    type: taskData.type,
                    coins: taskData.coins,
                    previousCoins: taskData.previousCoins,
                },
                true
            )
        );
    }

    public static lives(
        system: WorldSystem,
        taskData: IPlayerStateTaskData
    ): void {
        system.taskQueue.queue(
            new AnimationTask('RewardLives', system.animator, {
                lives: taskData.lives,
                previousLives: taskData.previousLives,
                scene: system.scene,
            })
        );
    }

    public static keys(
        system: WorldSystem,
        taskData: IPlayerStateTaskData
    ): void {
        system.taskQueue.queue(
            new AnimationTask('RewardKeys', system.animator, {
                type: taskData.type,
                keys: taskData.keys,
                previousKeys: taskData.previousKeys,
                scene: system.scene,
            })
        );
    }

    public static boosterTNT(
        system: WorldSystem,
        taskData: IPlayerStateTaskData
    ): void {
        system.taskQueue.queue(
            new AnimationTask('RewardBoosters', system.animator, {
                type: 'tnt',
                amount: taskData.amount,
                node: system.getCurrentLevelNode(),
            })
        );
    }

    public static boosterBullsEye(
        system: WorldSystem,
        taskData: IPlayerStateTaskData
    ): void {
        system.taskQueue.queue(
            new AnimationTask('RewardBoosters', system.animator, {
                type: 'bullseye',
                amount: taskData.amount,
                node: system.getCurrentLevelNode(),
            })
        );
    }

    public static boosterShuffle(
        system: WorldSystem,
        taskData: IPlayerStateTaskData
    ): void {
        system.taskQueue.queue(
            new AnimationTask('RewardBoosters', system.animator, {
                type: 'shuffle',
                amount: taskData.amount,
                node: system.getCurrentLevelNode(),
            })
        );
    }

    public static jokers(
        system: WorldSystem,
        taskData: IPlayerStateTaskData
    ): void {
        system.taskQueue.queue(
            new AnimationTask('RewardBoosters', system.animator, {
                type: 'joker',
                amount: taskData.amount,
                node: system.getCurrentLevelNode(),
            })
        );
    }

    public static extraCards(
        system: WorldSystem,
        taskData: IPlayerStateTaskData
    ): void {
        system.taskQueue.queue(
            new AnimationTask('RewardCards', system.animator, {
                cards: taskData.cards,
                node: system.getCurrentLevelNode(),
            })
        );
    }

    public static unlockBackcard(
        system: WorldSystem,
        taskData: IPlayerStateTaskData
    ): void {
        system.taskQueue.queue(new UnlockBackCardTask(taskData.backcardId));
    }

    public static levelNodeComplete(
        system: WorldSystem,
        taskData: IPlayerStateTaskData
    ) {
        system.taskQueue.queue(new LevelNodeCompleteTask());
    }

    public static createShortcut(
        system: WorldSystem,
        taskData: IPlayerStateTaskData
    ) {
        system.taskQueue.queue(new CreateShortcutTask());
    }
}
